import { Component } from 'react';
import { connect } from 'react-redux';
import { CourseTeaser, Player, PlayerListItem, SingleTeaser } from 'components/Webplayer';
import { createProcessForUnit, getUnitProtectedFileUrl, setPlayerProcess, setPlayerStatus, stopPlayer, trackPlayer } from 'redux/actions';
import {
  getCreatingProcessStatus,
  getCurrentPlayerProcess,
  getCurrentPlayerUnit,
  getPlayerStatus,
  getProtectedFileUrl
} from 'redux/reducers';
import PropTypes from 'prop-types';
import { NotFoundPage } from 'components';
import { CtaInfoSection } from 'components/Home';
import { TEXT } from 'locales/translations';
import { Link } from 'react-router-dom';
import IconNavLeft from 'images/webplayer/icon-nav-left.svg';
import { usePageTitle } from 'containers/PageTitleContainer/PageTitleContainer';
import { browserHistory } from 'redux/configureStore';
import { linkHandler } from 'utils/linkHandler';
import Style from './Webplayer.style';
import { ZppCourseRemoveTeaser, CtaZppInfoSection } from 'components/Component';

class Webplayer extends Component {
  componentDidMount() {
    const { content, trackPlayer, contentType, getUnitProtectedFileUrl } = this.props;
    if (contentType === 'course') {
      let selectedUnit = null;
      if (content && content.units) {
        content.units.forEach((unit, key) => {
          if (unit.completed && content.units.length >= key + 1 && !content.locked) {
            selectedUnit = content.units[key + 1];
          }
        });
      }
      if (selectedUnit) {
        trackPlayer(selectedUnit);
        getUnitProtectedFileUrl(selectedUnit.id);
        setPlayerStatus('load');
      } else {
        trackPlayer(content);
      }
    } else {
      trackPlayer(content);
    }
  }

  selectUnit = (unit) => {
    const { trackPlayer, content, currentlyPlayedUnit, setPlayerStatus, playerStatus, getUnitProtectedFileUrl, contentType } = this.props;
    if (!content.locked) {
      getUnitProtectedFileUrl(unit.id);
      if (currentlyPlayedUnit.id === unit.id) {
        if (playerStatus !== 'playing') {
          setPlayerStatus('resume');
        } else {
          setPlayerStatus('pausing');
        }
      } else {
        trackPlayer(unit);
      }
    }
    if (content.locked && content.protectedFile === unit.protectedFile && contentType === 'course') {
      trackPlayer(unit);
      if (playerStatus !== 'playing') {
        setPlayerStatus('resume');
      }
    }
  };

  goToPlans = () => {
    browserHistory.push(linkHandler.get('plans'));
  };

  handleSelectUnit = (unit, unitState) => {
    switch (unitState) {
      case 'locked':
        if (this.props.zppCourse) {
          return;
        }
        this.goToPlans();
        break;
      case 'available':
        return;
      default:
        this.selectUnit(unit);
    }
  };

  setProcess = (process) => {
    if (this.props.zppCourse) {
      return;
    }
    const { setPlayerProcess } = this.props;
    setPlayerProcess(process);
  };

  setPlayerStatus = (status) => {
    const { setPlayerStatus } = this.props;
    setPlayerStatus(status);
  };

  createPlayerListItem = (unit, key) => {
    const { currentlyPlayerProcess } = this.props;
    const unitState = this.determineUnitState(unit, key);

    return (
      <PlayerListItem
        key={unit.id}
        title={unit.title}
        time={key >= 0 ? unit.length : undefined}
        id={unit.id}
        process={currentlyPlayerProcess}
        state={unitState}
        selectUnit={() => this.handleSelectUnit(unit, unitState)}
      />
    );
  };

  determineUnitState = (unit, key) => {
    const { content, playerStatus, currentlyPlayedUnit } = this.props;
    const isCurrentUnit = unit.id === currentlyPlayedUnit.id;
    const isUnitLocked = content.locked;
    const isUnitCompleted = unit.completed;
    const isPreviousUnitCompleted = key > 0 && content.units[key - 1] && content.units[key - 1].completed;

    if (isCurrentUnit) {
      return playerStatus === 'playing' ? 'playing' : 'selected';
    }
    if (unit?.locked) {
      return 'locked';
    }
    if (isUnitCompleted) {
      return 'completed';
    }
    if (isUnitLocked || unit?.locked) {
      return 'locked';
    }
    if (isPreviousUnitCompleted || key === 0 || key === -1) {
      // or is intro
      return 'default';
    }
    return 'available';
  };

  playlist = () => {
    const { content, contentType, currentlyPlayedUnit } = this.props;

    if (!content || !currentlyPlayedUnit || !currentlyPlayedUnit.id) {
      return <></>;
    }
    let units = content.units ?? [];
    let intro = {
      ...content,
      title: contentType === 'course' ? 'Intro' : content.title
    };

    if (this.props.zppCourse) {
      units = units.slice(0, 2);
      intro = {
        ...content,
        title: 'Teaser'
      };
    }
    const tracks = units.map((unit, index) => {
      if (this.props.zppCourse) {
        return this.createPlayerListItem({ ...unit, locked: true });
      }
      return this.createPlayerListItem(unit, index);
    });
    return [this.createPlayerListItem(intro, -1), ...tracks];
  };

  render() {
    const { content, contentType } = this.props;
    const rightImage = content.pictureV2 || content.category?.icon;

    return (
      <Style className={`webplayer ${this.props.zppCourse ? 'webplayer--zpp-course' : ''}`} backgroundColor={content.backgroundColor}>
        {content && content.error && content.error.status === 404 ? (
          <NotFoundPage />
        ) : (
          <main className="webplayer">
            <section className="player-container" style={{ backgroundColor: content.backgroundColor }}>
              <div className="before-player">
                <Link className="back" to={linkHandler.get('library')}>
                  <img src={IconNavLeft} alt={TEXT.webplayer.iconNavLeft} className="left-icon" />
                  <span>{TEXT.webplayer.backButton}</span>
                </Link>
              </div>
              <Player
                {...this.props}
                createProcessForUnit={this.props.zppCourse ? () => {} : this.props.createProcessForUnit}
                setProcess={this.setProcess}
                setStatus={this.setPlayerStatus}
              >
                {this.props.zppCourse && <ZppCourseRemoveTeaser color={content.backgroundColor} />}
                {this.playlist()}
                {this.props.zppCourse && <div className="player-container-gradient" />}
              </Player>
              <div className="after-player d-none d-lg-flex">
                {rightImage && (
                  <img
                    src={rightImage}
                    alt={TEXT.webplayer.rightDecorativeImage}
                    className={contentType === 'course' ? 'w-100 h-auto' : 'right-image'}
                  />
                )}
              </div>
            </section>
            {this.props.zppCourse && <CtaZppInfoSection backgroundColor={content.backgroundColor} />}
            <section className="teaser-container">
              {contentType === 'course'
                ? content?.category?.courses?.length > 1 && (
                    <CourseTeaser category={content.category} course={content} buttonColor={content.backgroundColor} />
                  )
                : content?.category?.singles?.length > 1 && (
                    <SingleTeaser category={content.category} single={content} buttonColor={content.backgroundColor} />
                  )}
            </section>
            {!this.props.zppCourse && <CtaInfoSection />}
          </main>
        )}
      </Style>
    );
  }
}

Webplayer.propTypes = {
  content: PropTypes.object.isRequired,
  contentType: PropTypes.string.isRequired,
  currentlyPlayedUnit: PropTypes.object,
  currentlyPlayedUnitState: PropTypes.string,
  trackPlayer: PropTypes.func.isRequired,
  stopPlayer: PropTypes.func.isRequired,
  createProcessForUnit: PropTypes.func.isRequired,
  getUnitProtectedFileUrl: PropTypes.func.isRequired,
  setPlayerProcess: PropTypes.func.isRequired,
  currentlyPlayerProcess: PropTypes.number,
  setPlayerStatus: PropTypes.func.isRequired,
  playerStatus: PropTypes.string.isRequired,
  protectedFileUrl: PropTypes.string,
  token: PropTypes.string,
  creatingProcessStatus: PropTypes.bool,
  match: PropTypes.object.isRequired,
  zppCourse: PropTypes.object
};

Webplayer.defaultProps = {
  content: {},
  playerStatus: 'pausing',
  zppCourse: null
};

const mapStateToProps = (state, props) => {
  const content = { ...props.content };
  if (props.zppCourse) {
    content.isNotFastForwardable = false;
    content.length = props.zppCourse?.courseType === 'sda' ? 243 : 101;
    content.protectedFile = `https://static.balloonapp.de/audios/${
      props.zppCourse?.courseType === 'sda' ? 'balloon-kkk-einfuehrung.mp3' : 'balloon-kk-resilienz-einfuehrung.mp3'
    }`;
  }
  return {
    currentlyPlayedUnit: getCurrentPlayerUnit(state),
    currentlyPlayerProcess: getCurrentPlayerProcess(state),
    playerStatus: getPlayerStatus(state),
    creatingProcessStatus: getCreatingProcessStatus(state),
    protectedFileUrl: getProtectedFileUrl(state),
    content
  };
};

const withPageTitle = (WrappedComponent) => {
  return (props) => {
    const { content, contentType } = props;
    usePageTitle(`${content.title} | ${contentType === 'course' ? 'Kurs' : 'Übung'}`);
    return <WrappedComponent {...props} />;
  };
};

export default connect(mapStateToProps, {
  trackPlayer,
  stopPlayer,
  setPlayerProcess,
  setPlayerStatus,
  createProcessForUnit,
  getUnitProtectedFileUrl
})(withPageTitle(Webplayer));
